import {
  Badge as BadgeSelection,
  BadgeProps,
  Button,
  useMantineTheme,
} from "@mantine/core";
import { CloseCircle } from "iconsax-react";

interface IProps extends BadgeProps {
  contain?: string;
  textDisabled?: string;
  onClick?: () => void;
}

const TagSelection = ({ contain, textDisabled, onClick, ...props }: IProps) => {
  const theme = useMantineTheme();

  return (
    <BadgeSelection
      {...props}
      styles={{
        root: {
          width: "fit-content",
          height: "36px",
          borderRadius: "20px",
          padding: "8px 12px",
          background: !!contain
            ? theme.colors.primaryOpacity[1]
            : theme.colors.basic[1],
          color: !!contain ? theme.colors.primary[0] : theme.colors.basic[0],
          fontWeight: !!contain ? 600 : 500,
        },
        inner: {
          width: "fit-content",
        },
        rightSection: {
          display: !!contain ? "block" : "none",
        },
      }}
      rightSection={
        <Button
          bg={"transparent"}
          p={0}
          sx={{
            ":hover": {
              backgroundColor: "transparent",
            },
          }}
          style={{ border: "none" }}
          type="button"
          onClick={onClick}
        >
          <CloseCircle
            size="16"
            color={theme.colors.alerts[0]}
            variant="Bold"
          />
        </Button>
      }
    >
      {contain ? contain : textDisabled}
    </BadgeSelection>
  );
};

export default TagSelection;
